import React from 'react'
import { Button } from '@app/components/general'
import { _ONBOARDED } from '@app/lib/cookies/names'
import { GrConnect, GrDocumentTest, GrLineChart, GrSort } from 'react-icons/gr'
import { classNames } from '@app/utils/classes'
import { useTranslation } from '@app/lib/hooks/useTranslation'
import { FormDialogMock } from '../form-dialog-mock'
import { AuthMenuMock } from './auth-menu-mock'

const btnStyles = 'flex place-items-center dark:border-gray-800 border'
const btnHoverStyles =
  'border-gray-300 dark:border-gray-300 hover:border-blue-600 hover:text-blue-600 dark:hover:border-blue-600'
const iconStyles = 'grIcon text-xs'

// right bar
export type RightBarProps = {
  onQueryEvent(x: any): void
  onScanAllEvent?(x: any): void // scan all websites
  onWebsiteSort(x: any): void
  onAnalyticsEvent(): void
  queryModalVisible?: boolean
  sortModalVisible?: boolean
  premiumEnabled?: boolean // used to detect prem atm
  translation?: string
  authenticated?: boolean
  dialogDisabled?: boolean
}

export const RightBarMock = ({
  onWebsiteSort,
  premiumEnabled,
  onQueryEvent,
  onScanAllEvent,
  queryModalVisible,
  sortModalVisible,
  onAnalyticsEvent,
  translation,
  authenticated,
  dialogDisabled,
}: RightBarProps) => {
  const { t } = useTranslation(translation || 'dashboard')

  const disabledStyles = !premiumEnabled
    ? 'text-gray-300 dark:border-gray-600 dark:text-gray-600 hover:bg-inherit'
    : btnHoverStyles

  const syncText = t('sync')
  const sortWebsiteText = `${t('sort')} ${t('websites')}`.toLowerCase()
  const analyticsViewText = t('view-all-analytics')
  const performScan = t('perform-tip')
  const scanAllText = `${syncText} ${t('all-sites')}`.toLowerCase()

  return (
    <div className='flex gap-x-1.5 text-sm place-content-end w-full md:flex-1 pb-2'>
      <div className='flex gap-x-2 overflow-x-auto'>
        <Button
          onClick={onAnalyticsEvent}
          className={classNames(btnStyles, disabledStyles)}
          iconButton
          disabled={!premiumEnabled}
          border={false}
          title={analyticsViewText}
        >
          <span className='sr-only'>{analyticsViewText}</span>
          <GrLineChart className={iconStyles} />
        </Button>
        <Button
          disabled={!premiumEnabled}
          onClick={onWebsiteSort}
          iconButton
          border={false}
          title={sortWebsiteText}
          className={classNames(
            btnStyles,
            sortModalVisible
              ? 'border-blue-800 dark:border-blue-800 text-blue-900 hover:text-gray-400 hover:border-gray-400 dark:hover:text-gray-300 dark:hover:border-gray-300'
              : '',
            disabledStyles
          )}
        >
          <span className='sr-only'>{sortWebsiteText}</span>
          <GrSort className={iconStyles} />
        </Button>
        {onScanAllEvent ? (
          <Button
            onClick={onScanAllEvent}
            className={classNames(btnStyles, disabledStyles)}
            title={scanAllText}
            disabled={!premiumEnabled}
            iconButton
            border={false}
          >
            <span className='sr-only'>{syncText}</span>
            <GrConnect className={iconStyles} />
          </Button>
        ) : null}
        <Button
          onClick={onQueryEvent}
          disabled={!premiumEnabled}
          className={classNames(
            btnStyles,
            btnHoverStyles,
            queryModalVisible ? 'border-blue-800 text-blue-800' : '',
            disabledStyles
          )}
          iconButton
          title={performScan}
          border={false}
        >
          <span className='sr-only'>{performScan}</span>
          <GrDocumentTest className={iconStyles} />
        </Button>
        <FormDialogMock
          buttonTitle={<span className='sr-only'>{t('subscribe')}</span>}
          buttonStyles={classNames(
            'flex place-items-center',
            btnStyles,
            btnHoverStyles,
            'p-3 rounded-full'
          )}
          iconButton
          icon
          dialogDisabled={dialogDisabled}
          translation={translation}
        />
      </div>
      <AuthMenuMock
        authenticated={authenticated}
        className={'px-1.5'}
        dashboard
      />
    </div>
  )
}
